import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { IS_WEB_VIEW } from "common/constants.ts";

const usePageTracking = () => {
  const [initialized, setInitialized] = useState(false);
  const location = useLocation();

  const initializeGa = (env?: string) => {
    if (env === "production") {
      ReactGA.initialize("G-3XKJVKR0XX");
      setInitialized(true);
    }
  };

  useEffect(() => {
    initializeGa(`${import.meta.env.VITE_APP_ENVIRONMENT}`);
  }, []);

  useEffect(() => {
    if (initialized) {
      const pathName = (location.pathname + location.search)
        .replace(/\/?\d+/g, "")
        .split("?")[0];
      ReactGA.send({
        hitType: "pageview",
        page: pathName,
        is_mobile: IS_WEB_VIEW,
      });
    }
  }, [location, initialized]);
};

export default usePageTracking;
